import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/library/Button/Button';
import styles from './Modal.module.css';
import type { ConfigState } from 'services/store/features/Config/types';

interface Props {
  successEligibleTest?: boolean;
  closeModal: () => void;
  config: ConfigState;
};

export default function WaitingEligibleModal({
  successEligibleTest, closeModal, config,
}: Props) {
  const { t } = useTranslation();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (successEligibleTest === false) setError(true);
  }, [successEligibleTest, setError]);

  return (
    <div className={styles.bodyModal}>
      <div>
        <img className={styles.icon} src={`${process.env.PUBLIC_URL}/images/spinner-of-dots.svg`} alt="loading" />
      </div>
      <h3>{t('modal.waiting')}</h3>
      {error ? (
        <>
          <p className={`${styles.error} ${styles.text} ${styles.font30}`}>{t('modal.invalidMessage')}</p>
          <Button
            className={styles.button}
            variant="fill"
            type="secondary"
            label={t('modal.invalidButton')}
            onButtonClick={() => closeModal()}
          />
          <p className={`${styles.text} ${styles.font14}`}>
            {t('modal.successHelper')}
            &nbsp;
            <Button
              className={styles.ghostButton}
              variant="ghost"
              type="secondary"
              label={t('navigation.takeRdv')}
              onButtonClick={() => window.open(config.calendly)}
            />
          </p>
        </>
      ) : <></>}
    </div>
  );
}
